import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import type { AddressLookupRow, AddressCheckResponse_v2 } from '../types/api/generated';
import { AddressLookupRowSchema, AddressCheckResponseSchema } from '../types/api/schemas';
import { validateResponse } from './validateResponse';

export const addressApi = createApi({
    reducerPath: 'addressApi',
    baseQuery,
    endpoints: (builder) => ({
        mdmAddressLookup: builder.mutation<AddressLookupRow[], unknown>({
            query: (body) => ({ url: 'api/v2/address/mdm-address-lookup', method: 'POST', body }),
            transformResponse: validateResponse(AddressLookupRowSchema.array()),
        }),
        mdmAddressCheck: builder.mutation<AddressCheckResponse_v2, unknown>({
            query: (body) => ({ url: 'api/v2/address/mdm-address-check', method: 'POST', body }),
            transformResponse: validateResponse(AddressCheckResponseSchema),
        }),
        exusAddressLookup: builder.mutation<AddressLookupRow[], unknown>({
            query: (body) => ({ url: 'api/v2/global/exus-address-lookup', method: 'POST', body }),
            transformResponse: validateResponse(AddressLookupRowSchema.array()),
        }),
    }),
});

export const {
    useMdmAddressLookupMutation,
    useMdmAddressCheckMutation,
    useExusAddressLookupMutation,
} = addressApi;
